import { useCallback } from 'react';
import { triggerHaptic, type HapticStyle } from '../lib/haptics';

export type { HapticStyle };

/**
 * Cross-platform haptics for native feel on iOS/Android via Capacitor.
 * On web (or if plugin unavailable) all calls are no-ops.
 *
 * Most buttons get rich, weighted haptics automatically on touch-down via
 * `NativeGestures`. Reach for this hook when you need an explicit semantic
 * buzz that isn't a simple press — drag reorder, swipe-back commit, async
 * success/error, etc.
 *
 * Calls collapse into a global pointerdown on the same press so handlers that
 * still call `impact()` won't double-buzz.
 */
export function useHaptics() {
  const impact = useCallback(
    (style: HapticStyle = 'light') => triggerHaptic(style, { force: true, collapseRecent: true }),
    []
  );
  return { impact };
}
